module.exports = __webpack_public_path__ + "img/fondeador.cbe1f6f1.png";